import { render, staticRenderFns } from "./shopee-auth.vue?vue&type=template&id=085da53c&scoped=true"
import script from "./shopee-auth.vue?vue&type=script&lang=js"
export * from "./shopee-auth.vue?vue&type=script&lang=js"
import style0 from "./shopee-auth.vue?vue&type=style&index=0&id=085da53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085da53c",
  null
  
)

export default component.exports